import { apiFetch } from "./client";
import type { MeetingKind } from "./client360Meetings";

/**
 * D-134 MEETINGS-PROSPECT (P0) — лід = Account зі cCOnboardingStatus='prospect'.
 *
 * НЕ нова entity, НЕ Contact-сутність (контакт = поля на лід-Account). Зустріч з лідом —
 * account-centric (target_account_id=лід, target_holding_id=NULL); existing-клієнти
 * лишаються holding-флоу. Пошук = anti-dup ПЕРЕД inline-створенням (простий exact, НЕ fuzzy).
 */

export interface ProspectRow {
  id: string;
  name: string;
  contactPerson: string | null;
  phone: string | null;
  email: string | null;
  city: string | null;
  comment: string | null;
  onboardingStatus?: string;
}

export interface ProspectListResponse {
  items: ProspectRow[];
}

export interface CreateProspectPayload {
  name: string;
  contactPerson?: string;
  phone?: string;
  email?: string;
  city?: string;
  comment?: string;
}

/** Лід-зустріч payload — той самий контракт, що holding-зустріч, без contact/holding. */
export interface ScheduleProspectMeetingPayload {
  kind: MeetingKind;
  plannedAt: string;
  durationMinutes: 30 | 60 | 90;
  goal?: string;
  expectedResult?: string;
}

export interface ScheduleProspectMeetingResponse {
  id: string;
  holdingId: null;
  accountId: string;
  isProspect: true;
  kind: MeetingKind;
  plannedAt: string;
  durationMinutes: number;
  meetingStatus: string;
  source: "manual";
}

/** W2 — пошук серед існуючих prospect-Account (вибір + anti-dup). */
export function fetchProspectList(
  q: string,
  signal?: AbortSignal,
): Promise<ProspectListResponse> {
  return apiFetch<ProspectListResponse>("/Custom/frontend/prospects", {
    query: { q: q || undefined },
    signal,
  });
}

/** W3 — inline-створення ліда. */
export function createProspect(body: CreateProspectPayload): Promise<ProspectRow> {
  return apiFetch<ProspectRow>("/Custom/frontend/prospects", {
    method: "POST",
    body,
  });
}

/** W4 — зустріч з лідом (account-centric, holding=NULL). */
export function scheduleProspectMeeting(
  accountId: string,
  body: ScheduleProspectMeetingPayload,
): Promise<ScheduleProspectMeetingResponse> {
  return apiFetch<ScheduleProspectMeetingResponse>(
    `/Custom/frontend/prospects/${encodeURIComponent(accountId)}/meetings`,
    { method: "POST", body },
  );
}
